import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { PreferencesService } from '@src/core/services';

import { SessionService } from '../services/session.service';

@Injectable({
  providedIn: 'root',
})
export class SettingsGuard {
  private readonly router = inject(Router);
  private readonly preferencesService = inject(PreferencesService);
  private readonly session = inject(SessionService);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const associationId = route.params['associationId'];
    if (!!associationId) {
      if (this.session.isLogged()) {
        const settings = await lastValueFrom(this.preferencesService.getDataByOrganisationId(associationId));

        if (!!settings?.allowUserRegistrationForm) {
          return true;
        }
      } else {
        return true;
      }
    }

    this.router.navigate(['not-found']);
    return false;
  }

  async canActivateChild(route: ActivatedRouteSnapshot): Promise<boolean> {
    return this.canActivate(route);
  }
}
